@if (permissionLabel) {
  <h4>{{permissionLabel}}</h4>
}

@if (allUsers?.length) {
  <div class="pb-2 mb-4 input-list-wrapper">
    <h6 class="mt-4">{{usersLabel}}</h6>
    <div (clickedOutside)="userFieldFocused = false" appClickedOutside>

      <input type="text"
             class="rounded-input-base full-width"
             placeholder="Search User"
             (focus)="userFieldFocused = true"
             (click)="userFieldFocused = true"
             [formControl]="userSearchControl" />

      @if (userFieldFocused) {
        <div class="zint-base-card zint-card-white border-rounded-05 mt-1 max-height-15vh min-width-fit position-relative z-10 scrollbar-show">
          @for (user of filteredUsers$ | async; track user.userId) {
            <label class="d-flex flex-wrap align-items-center list-menu" [ngClass]="$last ? 'mb-0': ''">
              <input type="checkbox" class="mr-1"
                     [checked]="isSelected(user, 'user')"
                     (change)="togglePermission(user, 'user', $event.target.checked)" />
              {{user.email}}
              @if (user.isOrganisationAdmin) {
                <small class="text-muted ml-1">(Admin)</small>
              }
            </label>
          }
          @empty {
            <div class="p-2 text-muted">No users found</div>
          }
        </div>
      }
    </div>

    @if (selectedUserIds.size > 0) {
      <div class="position-relative">
        <span class="list-counter">{{selectedUserIds.size}}</span>
      </div>
      <div class="existing-list-wrapper" matTooltip="Existing users with permissions">
        @for (user of getSelectedItemsList('user'); track user.userId) {
          <span class="badge-light-grey existing-list-item">
            {{user.email}}
            <small class="badge-close-button cursor-pointer"
                   (click)="togglePermission(user, 'user', false)">
              <i class="fas fa-times"></i>
            </small>
          </span>
        }
      </div>
    }
  </div>
}

@if (allTeams?.length) {
  <div class="pb-2 mb-2 input-list-wrapper">
    <h6>{{teamsLabel}}</h6>
    <div (clickedOutside)="teamFieldFocused = false" appClickedOutside>
      <input type="text"
             class="rounded-input-base full-width"
             placeholder="Search Team"
             (focus)="teamFieldFocused = true"
             (click)="teamFieldFocused = true"
             [formControl]="teamSearchControl" />

      @if (teamFieldFocused) {
        <div class="zint-base-card zint-card-white border-rounded-05 mt-1 max-height-15vh min-width-fit position-relative z-10 scrollbar-show">
          @for (team of filteredTeams$ | async; track team.id) {
            <label class="d-flex flex-wrap align-items-center" [ngClass]="$last ? 'mb-0': ''">
              <input type="checkbox" class="mr-1"
                     [checked]="isSelected(team, 'team')"
                     (change)="togglePermission(team, 'team', $event.target.checked)" />
              {{team.name}}
            </label>
          } @empty {
            <div class="p-2 text-muted">No teams found</div>
          }
        </div>
      }
    </div>

    @if (selectedTeamIds.size > 0) {
      <div class="position-relative">
        <span class="list-counter">{{selectedTeamIds.size}}</span>
      </div>
      <div class="existing-list-wrapper" matTooltip="Existing teams with permissions">
        @for (team of getSelectedItemsList('team'); track team.id) {
          <span class="badge-light-grey existing-list-item">
            {{team.name}}
            <small class="badge-close-button cursor-pointer"
                   (click)="togglePermission(team, 'team', false)">
              <i class="fas fa-times"></i>
            </small>
          </span>
        }
      </div>
    }
  </div>
}
